import { render, staticRenderFns } from "./Contenido.vue?vue&type=template&id=4b0bc586&"
import script from "./Contenido.vue?vue&type=script&lang=js&"
export * from "./Contenido.vue?vue&type=script&lang=js&"
import style0 from "./Contenido.vue?vue&type=style&index=0&id=4b0bc586&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports